const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const formatTime = require('mn-utils/formatTime');
const EditIcon = require('@material-ui/icons/Edit').default;
const CreditCard = require('@material-ui/icons/CreditCard').default;
const {
  LINK_ADMIN_MPOS_CREDENTIALS,
  LINK_ADMIN_PAYOUT,
} = require('../../../../constants/links');
const {
  Link,
} = require('../../../../router');
const withState = require('../../../../utils/withState');
const getCountryByCode = require('../../../../utils/getCountryByCode');
const downloadKycPdf = require("../../../../utils/downloadKycPdf");
const {
  apiAdminAccountsKYCGet,
  apiAdminKYCVerificationStateUpdate,
} = require('../../../../api/admin/accountsKYC');
const {
  approveOpen,
} = require('../../../../emitters/popup');
const FieldA = require('../../../dumb/Field/A');
const ButtonF = require('../../../dumb/Button/F');
const Ripple = require('../../../dumb/Ripple');
const Menu = require('../../../dumb/Menu');
const Tooltip = require('../../../dumb/Tooltip/A');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const MenuVertIcon = require('../../../icons/MenuVert');
const Director = require('./Director');
const Document = require('./Document');
const Owners = require('./Owners');
const ButtonD = require("../../../dumb/Button/D");
const DownloadIcon = require("../../../icons/Download");


function getStatus(data) {
  return upperFirst(data.status || '-').replace('_', ' ');
}

function TitleA(props) {
  return (
    <div
      {...props}
      className={'f20 pt20 mt30 mb20 bs b bt1 bc505255 ' + (props.className || '')}
    />
  );
}
function TitleB(props) {
  return (
    <div
      {...props}
      className={'f16 mt20 mb15 ' + (props.className || '')}
    />
  );
}

module.exports = withState((setState) => {
  let _id;
  let _cancel = noop;

  const ITEMS = [
    getMenuItem('Approve', 'approved'),
    getMenuItem('Reject', 'rejected'),
    getMenuItem('Submitted', 'submitted'),
    getMenuItem('Pending', 'pending'),
  ];


  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      _cancel = apiAdminAccountsKYCGet({
        skipError: 1,
        account_id: _id,
      }).finally((error, data) => {
        setState({
          error,
          data,
          loading: false,
        });
      }).cancel;
    });
  }
  function getMenuItem(name, status) {
    return {name, onClick() {
      const id = _id;
      approveOpen({
        title: name,
        callback(message) {
          setState({
            loading: true,
          });
          apiAdminKYCVerificationStateUpdate({
            account_id: id,
            verification_state: status,
            verification_message: message,
          }).finally(update);
        },
      });
    }};
  }


  return (state, props) => {
    const {
      id,
    } = props;
    const data = state.data || {};
    const submittedAt = data.submitted_at;
    const company = data.company || {};
    const companyData = company.company || {};

    const profile = data.profile || {};
    const profileData = profile.profile || {};
    const imDirector = profileData.im_director;

    const owner = data.owner || {};

    const doc = data.document || {};

    const bank = data.bank || {};
    const bankData = bank.bank || {};

    const error = state.error;

    _id === id || update(_id = id);

    return (
      <>
        <div className="layoutRow fvaC fhaB mt5">
          <div className="layoutRow fvaC fhaE">
            {
              props.disabledSettings ? null : (
                <>
                  <ButtonF
                    className="wmin110 mr15"
                    component={Link}
                    href={`${LINK_ADMIN_PAYOUT}/${id}`}
                  >
                    <CreditCard/>
                    <div
                      className="pl10 ttN"
                    >Payout</div>
                  </ButtonF>
                  <ButtonF
                    className="mr15 wmin110"
                    component={Link}
                    href={LINK_ADMIN_MPOS_CREDENTIALS + id}
                  >
                    <EditIcon/>
                    <div
                      className="pl10 ttN"
                    >MPos credentials</div>
                  </ButtonF>
                </>
              )
            }
            <ButtonF
              className="mr15"
              onClick={() => downloadKycPdf(data)}
            >
              <DownloadIcon width="24" height="24" />
              <div className="pl15">Download</div>
            </ButtonF>
          </div>
          {
            props.disabledKyc ? null : (
              <Menu
                transformOriginTop="right top"
                transformOriginBottom="right bottom"
                items={ITEMS}
              >
                <Ripple
                  className="ml15 layoutRow fhaC fvaC sq50 r olN tdN dB cF dn
                    bgF.03:h"
                  centerRipple
                >
                  <MenuVertIcon className="w5 cF"/>
                </Ripple>
              </Menu>
            )
          }
        </div>
        <WrapperWithLoading
          loading={state.loading}
        >
          {
            error ? (
              <div
                className="hmin100 layoutRow fhaC fvaC p15 cF00 bgD r5"
              >{error.message}</div>
            ) : (
              <div>
                <TitleA>KYC</TitleA>
                <FieldA label="ID">{id}</FieldA>
                <FieldA label="Submitted at">
                  {submittedAt ? formatTime(submittedAt, '{yyyy}-{mm}-{dd} {HH}:{MM} {o}') : '-'}
                </FieldA>
                <FieldA label="Verification state">
                  {data.verification_state || '-'}
                </FieldA>
                <FieldA label="Verification message">
                  {data.verification_message || '-'}
                </FieldA>

                <TitleA>Company</TitleA>
                <FieldA label="status">
                  {getStatus(company)}
                </FieldA>
                <div className="mh-15 cfx (w1/2|ph15|lt)>1">
                  <div>
                    <FieldA label="Company name">
                      {companyData.company_name || '-'}
                    </FieldA>
                    <FieldA label="Company Registration number">
                      {companyData.reg_number || '-'}
                    </FieldA>
                    <FieldA label="Nature of business">
                      {companyData.nature || '-'}
                    </FieldA>
                    <FieldA label="Link to website with company details">
                      {companyData.link_company_details || '-'}
                    </FieldA>
                  </div>
                  <div>
                    <FieldA label="Business registration extract">
                      <Document data={company.business_registration_extract}/>
                    </FieldA>
                    <FieldA label="Proof of business operating address">
                      <Document data={company.business_operating_address}/>
                    </FieldA>
                    <FieldA label="Proof of shareholder structure">
                      <Document data={company.share_holder_structure}/>
                    </FieldA>
                  </div>
                </div>

                <TitleB>Business address</TitleB>
                <div className="mh-15 cfx (w1/2|ph15|lt)>1">
                  <div>
                    <FieldA label="Country">
                      {getCountryByCode(companyData.register_country)}
                    </FieldA>
                    <FieldA label="City *">
                      {companyData.register_city || '-'}
                    </FieldA>
                    <FieldA label="Street and house # *">
                      {companyData.register_street || '-'}
                    </FieldA>
                  </div>
                  <div>
                    <FieldA label="Address line 2">
                      {companyData.register_address || '-'}
                    </FieldA>
                    <FieldA label="ZIP / postal code *">
                      {companyData.register_zip || '-'}
                    </FieldA>
                  </div>
                </div>

                <TitleB>Operating address</TitleB>
                <div className="mh-15 cfx (w1/2|ph15|lt)>1">
                  <div>
                    <FieldA label="Country *">
                      {getCountryByCode(companyData.operating_country)}
                    </FieldA>
                    <FieldA label="City *">
                      {companyData.operating_city || '-'}
                    </FieldA>
                    <FieldA label="Street and house">
                      {companyData.operating_street || '-'}
                    </FieldA>
                  </div>
                  <div>
                    <FieldA label="Address line 2">
                      {companyData.operating_address || '-'}
                    </FieldA>
                    <FieldA label="ZIP / postal code *">
                      {companyData.operating_zip || '-'}
                    </FieldA>
                  </div>
                </div>

                <TitleA>Profile</TitleA>
                <FieldA label="status">
                  {getStatus(profile)}
                </FieldA>
                <FieldA label="The director is the account holder">
                  {imDirector ? 'Yes' : 'No'}
                </FieldA>
                <TitleB>Account holder</TitleB>
                <Director
                  data={profileData.holder}
                />
                {
                  imDirector ? null : (
                    <>
                      <TitleB>Director</TitleB>
                      <Director
                        data={profileData.director}
                      />
                    </>
                  )
                }

                <TitleA>Owners</TitleA>
                <FieldA label="status">
                  {getStatus(owner)}
                </FieldA>
                <Owners items={owner.list}/>

                <TitleA>Documents</TitleA>
                <FieldA label="status">
                  {getStatus(doc)}
                </FieldA>
                <div className="mh-15 cfx (w270|ph15|pb15|lt)>1">
                  {
                    map(doc.list, (item, index) => {
                      return (
                        <Tooltip
                          key={index}
                          title={item.file_name}
                        >
                          <Document data={item}/>
                        </Tooltip>
                      );
                    }, [])
                  }
                </div>

                <TitleA>Bank</TitleA>
                <FieldA label="status">
                  {getStatus(bank)}
                </FieldA>
                <div className="mh-15 cfx (w1/2|ph15|lt)>1">
                  <div>
                    <FieldA label="Bank name">
                      {bankData.name || '-'}
                    </FieldA>
                    <FieldA label="Bank address">
                      {bankData.address || '-'}
                    </FieldA>
                    <FieldA label="Switch code">
                      {bankData.swift_code || '-'}
                    </FieldA>
                  </div>
                  <div>
                    <FieldA label="Iban">
                      {bankData.iban|| '-'}
                    </FieldA>
                    <FieldA label="Fiat code">
                      {bankData.fiat_code || '-'}
                    </FieldA>
                  </div>
                </div>
              </div>
            )
          }
        </WrapperWithLoading>
      </>
    );
  };
}, {});
